import React from 'react';
import './Loading.css';

const BOS_SVG_PATH = 'M5.5,7.54c.18-2.65,3.19-4.1,5.37-2.59l13.24,9.11c2.18,1.49,1.92,4.77-.46,5.92l-14.34,6.92c-2.39,1.15-5.12-.7-4.92-3.32l1.11-16.03h.02s-.02,0-.02,0Z';

const Loading = ({ size = 'medium', fullscreen = false, minimal = false }) => {
    const savedColors = React.useMemo(() => {
        try {
            const raw = localStorage.getItem('businessBranding');
            if (raw) {
                const cached = JSON.parse(raw);
                if (cached?.mainColor) {
                    return { main: cached.mainColor, sec: cached.secColor || cached.mainColor };
                }
            }
        } catch { /* ignore */ }
        return { main: '#000000', sec: '#333333' };
    }, []);

    const svgSize = size === 'small' ? 24 : size === 'large' ? 52 : 36;

    return (
        <div className={`loading-container ${fullscreen ? 'fullscreen' : ''} ${minimal ? 'minimal' : ''}`}>
            <div className="loading-bos-logo" style={{ width: svgSize, height: svgSize }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 35.14 36"
                    width="100%"
                    height="100%"
                >
                    <rect
                        fill={savedColors.sec}
                        x="14.29"
                        y="11.92"
                        width="20.85"
                        height="20.85"
                        rx="3.14"
                        ry="3.14"
                        opacity="0.5"
                    />
                    <path
                        fill={savedColors.main}
                        d={BOS_SVG_PATH}
                    />
                </svg>
            </div>
        </div>
    );
};

export default Loading;
